import { billingService } from '@/shared/services/billing.service';

/**
 * Opens the provider's page where the card or UPI mandate of the plan in
 * force is updated (M-03): Razorpay's subscription link, Paddle's
 * update-payment-method page. The window is opened first and pointed there
 * once the link arrives, so a popup blocker does not eat it. False when
 * there is none.
 */
export async function openPaymentMethodPage(): Promise<boolean> {
  // Not 'noopener' here: with it window.open returns null. The opener is cut below instead.
  const win = typeof window !== 'undefined' ? window.open('', '_blank') : null;
  if (win) win.opener = null;
  try {
    const { url } = await billingService.getPaymentMethodLink();
    if (win) win.location.href = url;
    else window.location.assign(url);
    return true;
  } catch {
    win?.close();
    return false;
  }
}
